import { Link } from 'react-router-dom';

const TABS = [
  { to: "/admision", text: "Admisión" },
  { to: "/becas", text: "Becas 2027" },
];

const tabClass =
  "flex h-12 w-24 items-center justify-center bg-white text-xs font-bold uppercase tracking-wide text-green-900 shadow-md transition-colors hover:bg-green-900 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-900";

// Pestañas fijas al borde derecho (como "Consulte / Postular" en nido.cl), solo en pantallas anchas
export default function SideTabs() {
  return (
    <nav aria-label="Accesos directos" className="hidden xl:flex fixed right-0 top-1/2 z-40 -translate-y-1/2 flex-col gap-3">
      {TABS.map((tab) => (
        tab.to ? (
          <Link key={tab.text} to={tab.to} className={tabClass}>{tab.text}</Link>
        ) : (
          <a key={tab.text} href={tab.href} target="_blank" rel="noopener noreferrer" className={tabClass}>{tab.text}</a>
        )
      ))}
    </nav>
  );
}
